import { authenticatedPatch } from '../../../../../../api/request';

export default async function saveCompleteAppointment(saveData, setErrorMessage) {
    const onFail = () => setErrorMessage('Ocurrió un error guardando la actualización de la cita.');
    const url = '/appointment-doctor/complete-appointment';
    return await authenticatedPatch(url, onFail, saveData);
}
